import Input from "@material-ui/core/Input";
import styled from "styled-components";

export const Field = styled(Input)<{ error?: boolean }>`
  ${({ theme, ...props }) => `
    border: 2px solid ${theme.palette.error.main};
    border-color: ${props.error ? theme.palette.error.main : "transparent"};
    border-bottom: 0;
  `}
`;

export const StyledInput = styled.input`
  ${({ theme }) => `
    font-size :${theme.typography.pxToRem(14)};
    font-weight: 100;
    padding: ${theme.spacing(1, 0.5)};
    background: ${theme.palette.background.paper};
  `}
`;
